import React from 'react';
import { Link, matchPath } from 'react-router-dom';

import { hockeyFormatter } from '@nhl/formatter-utilities';

// TODO: Import CONSTANTS from @nhl/constants
import gameStateTypes from 'media-base-ui/utils/gameStateTypes';
import gameTypes from 'media-base-ui/utils/gameTypes';
import gameScheduleTypes from 'media-base-ui/utils/gameScheduleTypes';

import BroadcastInfo from '../broadcastInfo';

const sendGaClickEvent = game => {
    window.dataLayer.push({
        event: 'click',
        'event_category': 'Compact Game Component Click',
        'event_label': `game ${game.id}`
    });
};

const GameInfo = ({ game }) => {

    const gameState = game.state.id;
    const gameType =  game.gameType.id;
    const { gameScheduleState } = game;

    const renderScore = (score) => {
        const isLiveOrFinished = gameState > gameStateTypes.PREGAME;
        const isOfficial = gameState === gameStateTypes.OFFICIAL || gameType === gameTypes.PRE_SEASON && gameState === gameStateTypes.HARD_FINAL;
        const defeatedClass = (score === game.homeScore)
            ? score < game.visitingScore && isOfficial ? 'defeated ' : ''
            : score < game.homeScore && isOfficial ? 'defeated ' : '';

        return isLiveOrFinished ? <div className={defeatedClass}>{ score }</div> : null;
    };

    const renderAdditionalGameInfo = () => {
        const isPregame = gameState <= gameStateTypes.PREGAME && gameScheduleState.id === gameScheduleTypes.SCHEDULED;
        const match = matchPath('/games/:gameId', location.pathname + location.search);
        const showBoxscoreLink = match === null && gameScheduleState.id === gameScheduleTypes.SCHEDULED;

        if(isPregame){
            return <span>{ game.arenaName }</span>
        } else if(showBoxscoreLink) {
            return <Link to={`/games/${game.id}`} onClick={sendGaClickEvent.bind(this, game)} aria-label={`${game.visitingTeam.fullName} at ${game.homeTeam.fullName} Boxscore`}>Boxscore</Link>
        } else if(gameScheduleState.id > gameScheduleTypes.SCHEDULED) {
            return <span>{gameScheduleState.shortName}</span>
        }
        return null
    };

    const renderNetworks = () => {
        {/* renderNetworks is not included on the Games page because the fetch API doesn't include the data */}
        const isPregameOrLive = gameState < gameStateTypes.SOFT_FINAL;
        return isPregameOrLive ? <BroadcastInfo game={game} /> : null
    };

    return (
        <div className="game-info-container">

            { renderScore(game.visitingScore) }

            <div className="game-info">
                <span className="game-time">{hockeyFormatter.displayGameTime(game)}</span>
                <div className="additional-game-info">
                    {renderAdditionalGameInfo()}
                    {renderNetworks()}
                </div>
            </div>

            { renderScore(game.homeScore) }

        </div>
    )
};

export default GameInfo;
